import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { OccTiresWarrantyAdapter } from "./adapters/impl/occ-tires-warranty.adapter";
import { TiresWarrantyAdapter } from "./adapters/tires-warranty.adapter";

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: TiresWarrantyAdapter,
            useClass: OccTiresWarrantyAdapter
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule { }
